
<div *ngIf="isEdit == false" class="row">
  
  <div class="col-sm-4">{{link?.AnchorText}}</div>

  <div class="col-sm-5">
    <a href="{{link?.Url}}" target="external">{{link?.Url}}</a>
  </div>

  <div class="col-sm-3 text-right pull-right"> 

    <div class="btn-group">
        <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit()">
            <i class="fa fa-pencil"></i>
        </button>
        <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" (click)="delete()">
            <i class="fa fa-times"></i>
        </button>
      </div>

  </div>

</div>

<div *ngIf="isEdit == true" class="row">
  
    <div class="col-sm-4"> 
      <input type=text matInput placeholder="Anchor Text" [(ngModel)]="linkModelToEdit.AnchorText">
    </div>

    <div class="col-sm-5">
        <input type=text matInput placeholder="URL" [(ngModel)]="linkModelToEdit.Url">
    </div>

    <div class="col-sm-3 text-right pull-right">
      <div class="btn btn-sm btn-primary" (click)="save()">Save Link</div>
      <div class="btn btn-sm btn-secondary" (click)="isEdit = false">Cancel</div>
    </div>
  
  </div>